import { render, staticRenderFns } from "./AppContactEdit.vue?vue&type=template&id=dacfb7b4&scoped=true&"
import script from "./AppContactEdit.vue?vue&type=script&lang=js&"
export * from "./AppContactEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacfb7b4",
  null
  
)

export default component.exports